import { useState } from 'react'
// @mui
import {
  Box,
  Dialog,
  FormControlLabel,
  Checkbox,
  Typography,
  Stack,
} from '@mui/material'
import { LoadingButton } from '@mui/lab'
// helpers
import { getLocalStorage } from 'helpers/local-storage'
import useLocales from 'hooks/useLocales'

// ----------------------------------------------------------------------

export default function ExternalRedirectPopUp({
  isOpenExternalRedirectModal,
  openExternalRedirectModal,
  onRedirect,
}) {
  const { t } = useLocales()
  const [isRedirectLoading, setIsRedirectLoading] = useState(false)
  const [hidePopupChecked, setHidePopupChecked] = useState(
    getLocalStorage('externalRedirectPopup') === 'hide',
  )

  const handleCloseModal = () => {
    openExternalRedirectModal(false)
  }

  const handleOpenExternalLink = async () => {
    setIsRedirectLoading(true)
    localStorage.setItem(
      'externalRedirectPopup',
      hidePopupChecked ? 'hide' : 'show',
    )
    await onRedirect()
    handleCloseModal()
    setIsRedirectLoading(false)
  }

  return (
    <Dialog
      open={isOpenExternalRedirectModal}
      onClose={handleCloseModal}
    >
      <Box
        style={{
          padding: '20px',
          width: '100%',
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Stack direction="column" justifyContent="space-between">
          <Typography
            sx={(theme) => ({
              ...theme.typography.h5,
              wordWrap: 'break-word',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            })}
          >
            {t('key_open_checkin_organizer')}
          </Typography>
          <Typography
            variant="body2"
            my="16px"
            sx={(theme) => ({
              color: theme.palette.grey[500],
              wordWrap: 'break-word',
            })}
          >
            {t('key_open_checkin_desc')}
          </Typography>
        </Stack>
        <Stack direction="row" my="16px" spacing={2}>
          <LoadingButton
            id="b-common-externalredirect-open"
            fullWidth
            loading={isRedirectLoading}
            variant="contained"
            onClick={handleOpenExternalLink}
          >
            {t('key_open')}
          </LoadingButton>
          <LoadingButton
            id="b-common-externalredirect-cancel"
            fullWidth
            onClick={handleCloseModal}
            variant="outlined"
          >
            {t('key_cancel')}
          </LoadingButton>
        </Stack>
        <Stack>
          <FormControlLabel
            control={
              <Checkbox
                id="i-common-externalredirect-hide-checkbox"
                checked={hidePopupChecked}
                onChange={(
                  event: React.ChangeEvent<HTMLInputElement>,
                ) => setHidePopupChecked(event.target.checked)}
              />
            }
            label={
              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={0.5}
              >
                <Typography variant="subtitle2">
                  {t('key_dont_show_message')}
                </Typography>
              </Stack>
            }
          />
        </Stack>
      </Box>
    </Dialog>
  )
}
